import { useReveal } from "../../hooks/useReveal";

const THERAPIES = [
  {
    code: "CBT",
    name: "Cognitive Behavioural Therapy",
    description:
      "Examining the patterns of thinking and behaviour that keep distress in place — and gently working with them so you have more freedom and choice.",
    testid: "therapy-cbt-card",
  },
  {
    code: "ACT",
    name: "Acceptance & Commitment Therapy",
    description:
      "Building psychological flexibility: making room for difficult feelings while staying connected to what genuinely matters to you, and acting on it.",
    testid: "therapy-act-card",
  },
  {
    code: "CFT",
    name: "Compassion-Focused Therapy",
    description:
      "Working with shame, self-criticism, and threat — cultivating an inner relationship that feels safer, kinder, and more soothing.",
    testid: "therapy-cft-card",
  },
];

export const Therapies = () => {
  const ref = useReveal();

  return (
    <section
      id="therapies"
      data-testid="therapies-section"
      className="bg-[#FDFBF7]"
    >
      <div className="mx-auto max-w-[1320px] px-6 md:px-10 lg:px-16 py-20 md:py-20 lg:py-24">
        <div ref={ref} className="reveal">
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12 md:mb-16">
            <div>
              <p className="eyebrow-rule text-[11px] uppercase tracking-[0.28em] text-[#4A4D4A] mb-6">
                <span>02 · Evidence-Based Therapies</span>
              </p>
              <h2 className="font-serif-display text-3xl md:text-4xl lg:text-[3rem] leading-[1.1] tracking-[-0.02em] text-[#1A1C1A] font-medium max-w-3xl">
                Three approaches, woven through a{" "}
                <em className="italic font-normal text-[#1B2E26]">relational</em> &amp;{" "}
                <em className="italic font-normal text-[#1B2E26]">attachment</em> focus.
              </h2>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 border-t border-[#DCD7CE]">
            {THERAPIES.map((t, idx) => (
              <article
                key={t.code}
                data-testid={t.testid}
                className={`p-8 md:p-10 border-b border-[#DCD7CE] ${
                  idx !== THERAPIES.length - 1
                    ? "md:border-r border-[#DCD7CE]"
                    : ""
                } group transition-colors duration-300 hover:bg-[#F3F0EA]`}
              >
                <p className="font-serif-display text-7xl md:text-8xl text-[#1B2E26] leading-none font-light">
                  {t.code}
                </p>
                <h3 className="mt-8 font-serif-display text-2xl text-[#1A1C1A] leading-snug">
                  {t.name}
                </h3>
                <p className="mt-4 text-[#4A4D4A] text-base leading-relaxed">
                  {t.description}
                </p>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
